/**
 * @generated SignedSource<<3bd3a45fe865d5db3f06b7b96084ea43>>
 * @relayHash 397a87d8861b66e120ed052f1a581eb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a6608a2d3448a812b06af08ba81ed719f7d2b243aa3fc4051c538e7ba70236d3

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateCoverPictureMutationBlogDeleteMutation$variables = {
  blogPostId: string;
  propertyKey: string;
};
export type useUpdateCoverPictureMutationBlogDeleteMutation$data = {
  readonly confluence: {
    readonly deleteBlogPostProperty: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateCoverPictureMutationBlogDeleteMutation = {
  response: useUpdateCoverPictureMutationBlogDeleteMutation$data;
  variables: useUpdateCoverPictureMutationBlogDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "blogPostId",
                "variableName": "blogPostId"
              },
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
        "kind": "LinkedField",
        "name": "deleteBlogPostProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateCoverPictureMutationBlogDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateCoverPictureMutationBlogDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "397a87d8861b66e120ed052f1a581eb0",
    "id": "a6608a2d3448a812b06af08ba81ed719f7d2b243aa3fc4051c538e7ba70236d3",
    "metadata": {},
    "name": "useUpdateCoverPictureMutationBlogDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCoverPictureMutationBlogDeleteMutation($propertyKey:String!,$blogPostId:ID!){confluence{deleteBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId}){success}}}"
  }
};
})();

(node as any).hash = "d1d19eeb3cea2c92617e6a900794a511";

export default node;
